import { Card } from './Card';
import {
  NUMBER_CARD_VALUES,
  MODIFIER_CARD_VALUES,
  ACTION_CARD_VALUES,
  type Card as CardType,
} from '@flip7/shared';

interface CardGridProps {
  selectedCards: CardType[];
  onCardToggle: (card: CardType) => void;
  disabled?: boolean;
}

function isCardSelected(card: CardType, selectedCards: CardType[]): boolean {
  return selectedCards.some(c => c.type === card.type && c.value === card.value);
}

export function CardGrid({ selectedCards, onCardToggle, disabled }: CardGridProps) {
  return (
    <div className="card-grid" aria-label="Card selection grid">
      <div className="card-grid__section">
        <span className="card-grid__section-title">Number Cards</span>
        <div className="card-grid__cards">
          {NUMBER_CARD_VALUES.map((value) => {
            const card: CardType = { type: 'number', value };
            return (
              <Card
                key={`num-${value}`}
                card={card}
                selected={isCardSelected(card, selectedCards)}
                onClick={disabled ? undefined : () => onCardToggle(card)}
              />
            );
          })}
        </div>
      </div>

      <div className="card-grid__section">
        <span className="card-grid__section-title">Modifiers</span>
        <div className="card-grid__cards">
          {MODIFIER_CARD_VALUES.map((value) => {
            const card: CardType = { type: 'modifier', value };
            return (
              <Card
                key={`mod-${value}`}
                card={card}
                selected={isCardSelected(card, selectedCards)}
                onClick={disabled ? undefined : () => onCardToggle(card)}
              />
            );
          })}
        </div>
      </div>

      <div className="card-grid__section">
        <span className="card-grid__section-title">Action Cards</span>
        <div className="card-grid__cards">
          {ACTION_CARD_VALUES.map((value) => {
            const card: CardType = { type: 'action', value };
            return (
              <Card
                key={`act-${value}`}
                card={card}
                selected={isCardSelected(card, selectedCards)}
                onClick={disabled ? undefined : () => onCardToggle(card)}
              />
            );
          })}
        </div>
      </div>
    </div>
  );
}
